
import React from "react";


export const SearchChatIcon = ({ color }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_3086_11205)">
    <path d="M12.5 19.5833C12.5 19.8133 12.3133 20 12.0833 20H3.75C1.6825 20 0 18.3175 0 16.25V3.75C0 1.6825 1.6825 0 3.75 0H14.5833C15.7317 0 16.6667 0.934167 16.6667 2.08333V8.75C16.6667 8.98 16.48 9.16667 16.25 9.16667C16.02 9.16667 15.8333 8.98 15.8333 8.75V2.08333C15.8333 1.39417 15.2725 0.833333 14.5833 0.833333H3.75C2.14167 0.833333 0.833333 2.14167 0.833333 3.75V16.25C0.833333 17.8583 2.14167 19.1667 3.75 19.1667H12.0833C12.3133 19.1667 12.5 19.3533 12.5 19.5833ZM5.41667 5.83333C5.18667 5.83333 5 6.02 5 6.25C5 6.48 5.18667 6.66667 5.41667 6.66667H11.25C11.48 6.66667 11.6667 6.48 11.6667 6.25C11.6667 6.02 11.48 5.83333 11.25 5.83333H5.41667ZM19.8783 19.8783C19.7967 19.96 19.69 20 19.5833 20C19.4767 20 19.37 19.9592 19.2883 19.8783L16.9108 17.5008C16.2692 18.0142 15.4667 18.3342 14.5833 18.3342C12.5158 18.3342 10.8333 16.6517 10.8333 14.5842C10.8333 12.5167 12.5158 10.8342 14.5833 10.8342C16.6508 10.8342 18.3333 12.5167 18.3333 14.5842C18.3333 15.4675 18.0133 16.27 17.5 16.9117L19.8775 19.2892C20.04 19.4517 20.0408 19.7158 19.8783 19.8783ZM14.5833 17.5C16.1917 17.5 17.5 16.1917 17.5 14.5833C17.5 12.975 16.1917 11.6667 14.5833 11.6667C12.975 11.6667 11.6667 12.975 11.6667 14.5833C11.6667 16.1917 12.975 17.5 14.5833 17.5Z" fill={color}/>
    </g>
    <defs>
    <clipPath id="clip0_3086_11205">
    <rect width="20" height="20" fill="white"/>
    </clipPath>
    </defs>
    </svg>
  );
};



